import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    jwtHelper: JwtHelperService = new JwtHelperService();
    private URL = environment.services.Identity;
    private token: string | null = null;

    constructor(
        private oStorageService: StorageService,
        private oHttpClient: HttpClient
    ) {
    }

    logout() {
        localStorage.clear();
        this.oStorageService.removeAll();
    }

    isAuthenticated(): boolean {
        //Obtener el token de memoria, Verificar si el token existe y no ha expirado
        const token = this.getToken();
        if (token === null)
            return false;
        return this.jwtHelper.isTokenExpired(token) === false && this.isAuthenticatedInValue();
    }

    isAuthenticatedInValue(): boolean {
        // Implementa lógica adicional si es necesario para verificar otras condiciones de autenticación
        // por ejemplo, verifica roles, permisos, etc.
        const token = this.getToken();
        if (token === null) {
            return false;
        }
        const decodedToken = this.jwtHelper.decodeToken(token);
        if (decodedToken === null) {
            return false;
        }
        return true;
    }

    fetchToken(subject: string): void {
        const request = {
            subject: subject,
        };

        this.oHttpClient.post<any>(`${this.URL}Token/generar-token`, request)
            .subscribe({
                next: (response) => {
                    if (response.bSuccess && response.oData) {
                        const tokenJWT = response.oData;
                        this.setToken(tokenJWT);
                    } else {
                        console.error('No se pudo generar el token:', response.sMessage);
                    }
                },
                error: (error) => {
                    console.error('Error al obtener el token:', error);
                }
            });
    }

    getToken(): string | null {
        return this.token;
    }

    setToken(token: string): void {
        this.token = token;
    }

    clearToken(): void {
        this.token = null;
    }

    renewToken(subject: string): Observable<string> {
        const headers = new HttpHeaders().set('X-Api-Key', 'my-api-key');

        const renovarRequest = {
            subject
        };

        return this.oHttpClient.post<any>(`${this.URL}Token/renovar-token`, renovarRequest).pipe(
            map(response => {
                if (response.bSuccess && response.oData) {
                    const newToken = response.oData;
                    this.setToken(newToken);
                    return newToken;
                } else {
                    console.error('No se pudo renovar el token:', response.sMessage);
                    throw new Error(response.sMessage || 'No se pudo renovar el token');
                }
            })
        );
    }
}
